var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaveAudioWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 10,
    viewBox: "0 0 75 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6242_23692)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 3.5,
    width: 1,
    height: 3,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3.5,
    width: 1,
    height: 3,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3.5,
    width: 1,
    height: 3,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2.5,
    width: 1,
    height: 5,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 3.5,
    width: 1,
    height: 3,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 3.5,
    width: 1,
    height: 3,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 1,
    width: 1,
    height: 8,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 3.5,
    width: 1,
    height: 3,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 3.5,
    width: 1,
    height: 3,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 3.5,
    width: 1,
    height: 3,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 2.5,
    width: 1,
    height: 5,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 3.5,
    width: 1,
    height: 3,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 3.5,
    width: 1,
    height: 3,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 1,
    width: 1,
    height: 8,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 3.5,
    width: 1,
    height: 3,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 3.5,
    width: 1,
    height: 3,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 3.5,
    width: 1,
    height: 3,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 2.5,
    width: 1,
    height: 5,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 3.5,
    width: 1,
    height: 3,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 3.5,
    width: 1,
    height: 3,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 1,
    width: 1,
    height: 8,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 1,
    width: 1,
    height: 8,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 1,
    width: 1,
    height: 8,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 4,
    width: 1,
    height: 2,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 4,
    width: 1,
    height: 2,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 4,
    width: 1,
    height: 2,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 4,
    width: 1,
    height: 2,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 4,
    width: 1,
    height: 2,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 4,
    width: 1,
    height: 2,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 4,
    width: 1,
    height: 2,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 4,
    width: 1,
    height: 2,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 4,
    width: 1,
    height: 2,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 4,
    width: 1,
    height: 2,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 4,
    width: 1,
    height: 2,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 2.5,
    width: 1,
    height: 5,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 2.5,
    width: 1,
    height: 5,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 1,
    width: 1,
    height: 8,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 2.5,
    width: 1,
    height: 5,
    rx: 0.5,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6242_23692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveAudioWhite);
export default __webpack_public_path__ + "static/media/waveAudioWhite.a360ea5950d027f5583be69868dfac08.svg";
export { ForwardRef as ReactComponent };